import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { cloneElement, Children, Component } from 'react';
import { KeyboardModeContext } from '../../../components/AppProvider/KeyboardModeProvider';
import { warnIfFragment } from '../../utils/warnIfFragment/warnIfFragment';
import { RTEContextConsumer } from '../../context/RTEContext';
import { Layer } from '../Layer/Layer';
import { jsx as _jsx } from "react/jsx-runtime";
// Based on https://github.com/twbs/bootstrap/blob/v3.3.6/dist/js/bootstrap.js
function measureScrollbar() {
  const scrollDiv = document.createElement('div');
  /**
   * @temporary: this has to match the className in UIComponents/UIFullScreen as this is not present in our GlobalStyles atm
   */
  scrollDiv.className = 'uiFullScreen-scrollbar-measure';
  document.body.appendChild(scrollDiv);
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}
export class FullScreen extends Component {
  /**
   * @temporary: this has to match the className in UIComponents/UIFullScreen as this is not present in our GlobalStyles atm. https://github.com/HubSpotEngineering/UIComponents/blob/20d7b341285b6341e6389645df1b4a71564be78b/UIComponents/static/js/dialog/UIFullScreen.js#L21
   */

  constructor(props) {
    super(props);
    this.handleCloseComplete = () => {
      const {
        isKeyboardMode
      } = this.context;
      if (this._lastFocus) {
        if (isKeyboardMode) {
          this._lastFocus.focus();
        }
        this._lastFocus = null;
      }
      if (FullScreen.layerCount === 0) {
        this.restoreBackgroundScrolling();
      }
    };
    this._lastFocus = document.activeElement;
  }
  componentDidMount() {
    FullScreen.layerCount += 1;
    if (FullScreen.layerCount === 1) {
      this.disableBackgroundScrolling();
    }
  }
  componentWillUnmount() {
    FullScreen.layerCount -= 1;
  }
  disableBackgroundScrolling() {
    this.addFauxScrollbar();
    [document.documentElement, document.body].forEach(el => el.classList && el.classList.add(FullScreen.NO_SCROLL_CLASS));
  }
  restoreBackgroundScrolling() {
    this.removeFauxScrollbar();
    [document.documentElement, document.body].forEach(el => el.classList && el.classList.remove(FullScreen.NO_SCROLL_CLASS));
  }
  addFauxScrollbar() {
    const bodyHasScrollbar = document.body.clientWidth < window.innerWidth;
    if (bodyHasScrollbar) {
      // To avoid changing the body width when we disable scrollbar, we replace
      // the scrollbar with padding of equal width.
      const computedStyle = window.getComputedStyle(document.body);
      const originalBodyPaddingRight = computedStyle.paddingRight;
      const originalBodyPaddingRightNumber = parseFloat(originalBodyPaddingRight);
      FullScreen.originalBodyPaddingRight = originalBodyPaddingRight;
      document.body.style.paddingRight = `${measureScrollbar() + originalBodyPaddingRightNumber}px`;
    }
  }
  removeFauxScrollbar() {
    document.body.style.paddingRight = FullScreen.originalBodyPaddingRight;
  }
  render() {
    const _this$props = this.props,
      {
        children
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    warnIfFragment(children, 'FullScreen');
    return /*#__PURE__*/_jsx(RTEContextConsumer, {
      children: rteContext => /*#__PURE__*/_jsx(Layer, Object.assign({}, rest, {
        onCloseComplete: this.handleCloseComplete
        // Necessary for TinyMCE to prevent blur on the editor when component is clicked
        // https://github.com/HubSpotEngineering/structured-content/issues/702
      }, rteContext, {
        children: /*#__PURE__*/cloneElement(Children.only(children), {
          open: true
        })
      }))
    });
  }
}
FullScreen.displayName = 'FullScreen';
FullScreen.layerCount = 0;
FullScreen.NO_SCROLL_CLASS = 'uiFullScreenBackground';
FullScreen.originalBodyPaddingRight = '';
FullScreen.contextType = KeyboardModeContext;